import React from 'react';

import { Card, CardActionArea, CardActions, Switch, Typography } from "@mui/material"
import useCart from "../../../../../hooks/orders/CartProvider";
import useStyles from "./styles";

const ReturnMode = ({ disabled }) => {
    const { classes } = useStyles();
    const { sale: { returnMode }, toggleReturnMode } = useCart();
    
    return (
        <Card>
            <CardActionArea disabled={disabled} className={disabled && classes.cardAreaDisabled}>
                <CardActions
                    onClick={toggleReturnMode}
                    className={classes.cardArea}
                >
                    <Switch 
                        color="primary"
                        checked={returnMode}
                    /> 
                    <Typography variant='overline' display='block'>
                        Modo devolución
                    </Typography>
                </CardActions>
            </CardActionArea>
        </Card>
    )
}

export default ReturnMode;